PXUTheme.utils = PXUTheme.utils || {};
PXUTheme.utils.GetCart = async () => {
  return await fetch("/cart.js").then((res) => res.json());
}
PXUTheme.utils.FormatMoney = (value) => {
  return Shopify.formatMoney(value, $("body").data("money-format")).replace("USD", "").replace(".00", '')
}
PXUTheme.utils.AddItemsToCart = async (items_to_add) => {
  // items_to_add = [{
  //   quantity: qty,
  //   id: variant_id,
  //   selling_plan: selling_plan_id,
  //   properties: {}
  // }]
  return await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ items: items_to_add })
  })
}
PXUTheme.utils.UpdateCartItem = (item) => {
  if (!item) return;

  return fetch("/cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(item),
  });
}
PXUTheme.utils.Geolocate = async (address) => {
  if (!address) return;
  var geocoder = new google.maps.Geocoder();
  let results = await geocoder.geocode({ address: address });

  return results;
}
PXUTheme.utils.PromisesSequential = async (PromiseArr) => {
  let res = [];
  for (let i = 0; i < PromiseArr.length; i++) {
    res.push(await PromiseArr[i])
  }
  return res;  
}
PXUTheme.utils.ConvertStringToHTML = (str) => {
  let parser = new DOMParser();
  let doc = parser.parseFromString(str, 'text/html');
  return doc.body;
}

function MapsLoaded() {
  console.log('maps loaded!')
}

document.addEventListener('alpine:init', () => {
  var sticky_1 = new Sticky('#header');
  // 19 nov
    Alpine.data('ProductSlider', () => ({
    mounted() {
      let $section = this.$el;
      let options = {
        cellAlign: "center", 
        contain: true, 
        watchCSS: true,
        wrapAround: true,
        prevNextButtons: false, 
        pageDots: false,
      };
      let flickityEnabled = true;

      if (flickityEnabled) {
        $($section).flickity(options);
      }
    }
  }));
  
  Alpine.data('ProductQuotes', () => ({
    mounted() {
      let $section = this.$el;
      let options = {
        cellAlign: "left", 
        contain: true, 
        watchCSS: false,
        fade: true,
        wrapAround: true,
        prevNextButtons: false, 
        pageDots: true,
        autoPlay: 10000
      };
      let flickityEnabled = true;

      if (flickityEnabled) {
        $($section).flickity(options);
      }
    }
  }));
  
  Alpine.data('LogosCarousel', () => ({
    mounted() {
      let $section = this.$el;
      let options = {
        cellAlign: "left", 
        contain: true, 
        watchCSS: true,
        prevNextButtons: false, 
        pageDots: false
      };
      let flickityEnabled = true;

      // subscribe logo list
      if ($section.closest('.subscribe-logo-list')) {
        flickityEnabled = false;

        let $slides = [...$section.querySelectorAll('.logo-list__item')];
        [1,2,3].forEach(() => {
          $slides.forEach(($slide) => {
            $section.insertAdjacentElement('beforeend', $slide.cloneNode(true))
          });
        });
      }
      // console.log(options)

      if (flickityEnabled) {
        $($section).flickity(options);
      }
    }
  }));

  Alpine.data('FAQ_Accordion', () => ({
    mounted() {},
    e_CloseExpandedBlocks(e) {
      let $targetFaqBtn = e.target
      let target_controls = $targetFaqBtn.getAttribute('aria-controls')
      let $section = $targetFaqBtn.closest('.faq--faq')
      $section.querySelectorAll('button[aria-expanded="true"]').forEach($faqBtn => {
        let controls = $faqBtn.getAttribute('aria-controls')
        if (controls == target_controls) return
        $faqBtn.click()
      })
    }
  }));

  Alpine.data('FooterAccordionMenu', (menu) => ({
    flags: {
      is_mobile: !window.PXUTheme.media_queries.large.matches
    },
    mounted() {
      let am = this
      am.$el.setAttribute('aria-expanded', menu === 'footer-shop-menu')
    },
    e_ToggleMenu(e) {
      let am = this
      if (!am.flags.is_mobile) return
      let $menu = e.currentTarget.closest('.footer__menu')
      let expanded = JSON.parse($menu.getAttribute('aria-expanded'))
      let $links = $menu.querySelector('ul')
      $($links).slideToggle(() => {
        $menu.setAttribute('aria-expanded', !expanded)
      })
    }
  }));

  Alpine.data('FreeShipProgress', (cart) => ({
    cart: null,
    freeship: {
      threshold: 15000,
      progress: 0,
      active: false,
    },
    threshold: {
      freeship: 15000,
    },
    mounted() {
      let am = this;
      am.UpdateCart();

      document.addEventListener("ajaxcart:updated", Alpine.debounce(am.UpdateCart.bind(am)), 0);
    },
    async UpdateCart() {
      let am = this;
      am.cart = await PXUTheme.utils.GetCart();
      am.CheckFreeShip();
    },
    CheckFreeShip() {
      let am = this;
      am.freeship.active = am.cart.total_price >= am.freeship.threshold;
      let progressFreeship =
        (am.cart.total_price / am.freeship.threshold) * 100;

      let cart_hasSubscriptionItems = am.cart.items.find(item => item.selling_plan_allocation) !== undefined;
      if (cart_hasSubscriptionItems) {
        progressFreeship = 100;
        am.freeship.active = true;
      }
      
      am.$nextTick(() => {
        am.freeship.progress = progressFreeship > 100 ? 100 : progressFreeship;
      });
    },
    GetShipMessage() {
      let am = this;
      if (!am.cart) return "";
      let remaining = am.freeship.threshold - am.cart.total_price;
      remaining = PXUTheme.utils.FormatMoney(remaining);
      return `${remaining} away from free shipping!`;
    },
  }));

  Alpine.data('FAQListGroups', () => ({
    mounted() {
      this.render()
    },
    render() {
      let groups = [];
      let $faq_groups = document.querySelectorAll('.faq-title');
      $faq_groups.forEach(($item, index) => {
        let id = `faq-group--${ index }`;
        groups.push({
          title: $item.innerText,
          $item: $item,
          id: id
        });
      });

      let list_markup = groups.map((item) => {
        return `<li><a x-data="ScrollTo" @click.prevent="ScrollTo($event)" data-target="#${ item.id }" href="#${ item.id }">${ item.$item.outerHTML }</a></li>`
      }).join('');

      groups.forEach((item) => {
        item.$item.setAttribute('id', item.id);
      });

      let $first_faq = document.querySelector('.faq--image');
      $first_faq.classList.add('faq-groups-list');

      $first_faq.insertAdjacentHTML('beforeend', `
        <div class="list-items-wrap">
          <ul>${ list_markup }</ul>
          <p>Don’t see your question answered here? Write us at <a href="mailto:hi@thefullest.com">hi@thefullest.com</a> and we’ll be in touch!</p>
        </div>
      `);
    }
  }));

  Alpine.data('ScrollTo', () => ({
    flags: {
      is_mobile: !window.PXUTheme.media_queries.large.matches
    },
    init() {
      let am = this;
      am.$el.addEventListener('ScrollTo', (e) => {
        am.ScrollTo(e);
      })
    },
    ScrollTo(e) {
      let am = this;
      let $scroll_target = document.querySelector(e.currentTarget.dataset.target);
      let $header = document.querySelector('.header');
      let offset = $header ? $header.offsetHeight : 0;

      if (PXUTheme.template.indexOf('product') !== -1) {
        offset += am.flags.is_mobile ? 20 : 60;
      }

      if (PXUTheme.template.indexOf('page.subscribe-page') !== -1) {
        offset += am.flags.is_mobile ? 60 : 0;
      }

      let top = ($scroll_target.getClientRects()[0].top - offset - (am.flags.is_mobile ? 10 : 100)) + window.scrollY * (am.flags.is_mobile ? 1 : 1.25);
      // console.log(top)

      window.scrollTo({
        top: top,
        behavior: "smooth",
      });
    }
  }));

  Alpine.data('SubscriptionWidget', () => ({
    product: null,
    purchaseOption: 'subscribe',
    flags: {
      isSubscription: true,
      isOnetime: false,
      isPreorder: false,
      toggle_helper: false
    },
    selling_plans: [],
    selling_plan_id: '',
    qty: 1,
    mounted() {
      let am = this;
      am.product = JSON.parse(am.$el.dataset.product);
      am.$nextTick(am.UpdateFormSellingPlan.bind(am));

      am.$watch('purchaseOption', () => {
        am.flags.isSubscription = am.purchaseOption == 'subscribe';
        am.flags.isOnetime = !am.flags.isSubscription;
        am.$nextTick(am.UpdateFormSellingPlan.bind(am));
        am.qty = 1;
        am.UpdatePrice();
      });
      am.$nextTick(am.UpdatePrice.bind(am));

      // on form change, updatePrice
      let $product_form = am.$el.closest('.shopify-product-form');
      if ($product_form) {
        $product_form.addEventListener('change', (e) => {
          // console.log(e)
          am.UpdatePrice();
        });
      }

      // on variant change
      let $variant_selection = $product_form.querySelector('[data-variant-selection]');
      if ($variant_selection) {
        $variant_selection.addEventListener('variant-change', (e) => {
          // console.log(e);
          let productPrice = $product_form.querySelector('[name="purchase-option"][value="onetime"]').dataset.price;
          if(productPrice){
            productPrice = e.detail.variant.price;
          }
          
          am.UpdatePrice();
        });
      }

      // selling_plans
      if (am.product.selling_plan_groups.length) {
        am.selling_plans = [...am.product.selling_plan_groups].map((item, index) => {
          return {
            index: (index + 1),
            id: item.selling_plans[0].id,
            name: item.name,
            price_adjustment: {
              type: item.selling_plans[0].value_type,
              value: item.selling_plans[0].value
            }
          }
        });
        // console.log(am.selling_plans);
        am.selling_plan_id = am.selling_plans[0].id;
        am.$el.removeAttribute('x-cloak-hide');
      }
      else {
        am.purchaseOption = 'onetime';
        // am.$el.removeAttribute('x-cloak-hide');
      }

      // shop floater events
      document.addEventListener('shopfloater--add-to-cart', (e) => {
        am.purchaseOption = e.detail.type
        setTimeout(am.FormSubmit.bind(am), 1000)
      })
    },
    UpdateFormSellingPlan() {
      let am = this;

      let $product_form = am.$el.closest('.shopify-product-form');
      if (!$product_form) return;

      $product_form.querySelectorAll('[name=selling_plan]').forEach(($plan) => {
        $plan.value = am.flags.isSubscription ? am.selling_plan_id : ''
      })
    },
    UpdatePrice() {
      let am = this;
      let $form = am.$el.closest('.shopify-product-form');
      let $btn_atc = $form.querySelector('.button--add-to-cart');
      let $btn_price = $btn_atc.querySelector('.btn-price');
      let $btn_price2 = document.querySelector('.custom_money');
      console.log("$btn_price2",$btn_price2)
      let $qty = $form.querySelector('[name="quantity"]')
      let price = $form.querySelector('[name*="purchase-option"]:checked').dataset.price || $form.querySelector('.swatch__options input:checked').dataset.price;

      let qty = 1;
      if ($qty) {
        qty = parseInt($qty.value);
        $btn_price.innerHTML = `- ${ PXUTheme.utils.FormatMoney(price * qty) }`;
        $btn_price2.innerHTML = `${ PXUTheme.utils.FormatMoney(price * qty) }`;
      }

    },
    e_UpdateSellingPlan(e) {
      let am = this;
      am.selling_plan_id = e.target.value;
      am.UpdateFormSellingPlan();
    },
    FormSubmit() {
      let am = this
      let $form = am.$el.closest('.shopify-product-form')
      let $btn_atc = $form.querySelector('[data-add-to-cart-trigger]')
      $btn_atc.click()
    }
  }));

  Alpine.data('CustomKlaviyoBIS', () => ({
    list_id: '',
    variant_id: '',
    mounted() {
      let am = this
      document.addEventListener('OpenBISModal', (e) => {
        // console.log(e)
        e.preventDefault()
        am.variant_id = e.detail.e_orig.target.dataset.variant_id
        am.list_id = e.detail.e_orig.target.dataset.list_id

        if (!am.variant_id) {
          console.warn('No variant specified for BIS')
          return
        }
        am.OpenBISModal()
      })
    },

    OpenBISModal() {
      $.fancybox.open({
        src: '.klaviyo-modal',
        type: 'inline',
        dragToClose: false,
        opts: {
          baseClass: 'popup-modal',
          hash: false,
          infobar: false,
          toolbar: false,
          smallBtn: false,
          touch: {
            vertical: false,
            momentum: false
          },
          beforeShow() {
            // Remove previous slides (fix for theme editor)
            $('.popup-modal .fancybox-slide').empty()
          },
          afterShow() {
          },
          beforeClose() {
          }
        }
      });
    },

    CloseModal() {
      $.fancybox.close()
    },

    async e_SubmitForm(e) {
      console.log('ok')
      e.preventDefault()

      let $form = e.currentTarget.closest('form')
      let action_url = $form.getAttribute('action')
      let email = $form.querySelector('input[type="email"]').value; 
      let variant_id = $form.querySelector('input[name="variant"]').value; 
      
      // let res_submit = await fetch(action_url, {
      //   method: 'POST',
      //   body: new FormData($form)
      // });
      // let res_submit_json = await res_submit.json()
      // if (res_submit.ok) {
      //   $form.querySelector('.error_message').textContent = ''

      //   $form.querySelector('.completed_message').classList.remove('visually-hidden')
      //   setTimeout(() => {
      //     $form.querySelector('.completed_message').classList.add('visually-hidden')
      //     $.fancybox.close()
      //   }, 5000)
      // }
      // else {
      //   $form.querySelector('.error_message').textContent = res_submit_json.message
      // }

      // 30-10-2024 start
      function isEmail(email) {
        var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        return regex.test(email);
      }
       if (isEmail(email)) {
         const payload = {
            "data": {
              "type": "back-in-stock-subscription",
              "attributes": {
                "profile": {
                  "data": {
                      "type": "profile",
                      "attributes": {
                          "email": email,
                      }
                  }
                },
                "channels": ["EMAIL"],
              },
              "relationships": {
                "variant": {
                  "data": {
                    "type": "catalog-variant",
                    "id": "$shopify:::$default:::"+ variant_id
                  }
                }
              }
            }
         }
        let requestOptions = {
            method: 'POST',
            headers: {
              "Content-Type": "application/json",
              "revision":"2024-06-15"
            },
            body: JSON.stringify(payload),
        };    
        let klaviyoId = 'MYfCAF';
        fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=" + klaviyoId, requestOptions)
          .then(result => {
            $form.querySelector('.error_message').textContent = '';
            console.log('success',result);
            $form.querySelector('.completed_message').classList.remove('visually-hidden')
            setTimeout(() => {
              $form.querySelector('.completed_message').classList.add('visually-hidden')
              $.fancybox.close()
            }, 4000)
          }).catch(error => {
            console.log('Error:', error);
         });
       } else {
         $form.querySelector('.error_message').textContent = 'Invalid email.';
       }
      // 30-10-2024 end
      
    }
  }));

  Alpine.data('ShopFloater', () => ({
    flags: {
      is_mobile: !window.PXUTheme.media_queries.large.matches
    },
    mounted() {
      let am = this
      am.$el.closest('.shopify-section').style.setProperty('--header-height', `${document.querySelector('#header').offsetHeight}px`)
      setTimeout(am.CheckSticky.bind(am), 500)
    },
    e_HandleScroll(e) {
      // console.log(e)
      let am = this
      am.CheckSticky()
    },
    e_AddToCart(type) {
      document.dispatchEvent(new CustomEvent('shopfloater--add-to-cart', {detail: {type}}))
    },
    CheckSticky() {
      let am = this
      let $product = document.querySelector('.product_section')
      let $sticky_floater = am.$el.closest('.section-shop-floater')
      let $sticky_header = am.flags.is_mobile ? document.querySelector('#mobile-header') : document.querySelector('#header')

      let is_Sticky = window.pageYOffset >= $product.offsetHeight
      $sticky_floater.classList.toggle('sticky', is_Sticky)
      if (!am.flags.is_mobile) {
        $sticky_floater.style.top = `${ $sticky_header.offsetHeight }px !important`
      }
    }
  }))

  Alpine.data('FeaturedProductsCarousel', () => ({
    mounted() {
      let $section = this.$el;
      let $thumbs = $section.querySelectorAll('.product__thumbnail')
      if ($thumbs.length < 2) return
      
      let options = {
        cellAlign: "left", 
        contain: true, 
        watchCSS: true,
        prevNextButtons: true, 
        pageDots: false,
        wrapAround: true
      };

      $($section).flickity(options)
    }
  }))

  Alpine.data('ProductGalleryImage', () => ({
    mounted() {
      lazySizes.loader.unveil(this.$el.querySelector('img'))
    }
  }))

  Alpine.data('IconsWithTextCarousel', () => ({
    mounted() {
      let $section = this.$el;
      let options = {
        cellAlign: "left", 
        contain: true, 
        watchCSS: true,
        prevNextButtons: true, 
        pageDots: false,
        wrapAround: true,
        adaptiveHeight: true
      };

      $($section).flickity(options)
    }    
  }))

  Alpine.data('UpsellItemsCarousel', () => ({
    flags: {
      is_mobile: !window.PXUTheme.media_queries.large.matches
    },
    mounted() {
      let am = this
      let $section = this.$el
      let num_slides = $section.querySelectorAll('.upsell-item').length
      let prevNextButtons = false
      if (am.flags.is_mobile) {
        prevNextButtons = num_slides >= 2
      }
      else {
        prevNextButtons = num_slides > 2
      }
      let options = {
        cellAlign: "left", 
        contain: true, 
        watchCSS: false,
        prevNextButtons: prevNextButtons, 
        pageDots: false,
        wrapAround: false,
        adaptiveHeight: true
      };

      $($section).flickity(options)
    },
    async AddItemToCart(e) {
      let $target = e.currentTarget
      let items_to_add = [{
        quantity: 1,
        id: $target.dataset.variant_id
      }]
      await PXUTheme.utils.AddItemsToCart(items_to_add)
      PXUTheme.jsAjaxCart.updateView()
    }
  }))

  Alpine.data('CartItemSubscribe', () => ({
    async e_CartItemSubscribe() {
      let am = this
      let item_index = am.$el.dataset.item_index
      let selling_plan_id = am.$el.querySelector('select').value

      if (selling_plan_id == 'one-time') {
        selling_plan_id = null
      }

      let cart = await PXUTheme.utils.GetCart()
      let item = cart.items[item_index]
      let update = {
        id: item.key,
        quantity: item.quantity,
        selling_plan: selling_plan_id,
      }
      // console.log(update)

      let res_update = await PXUTheme.utils.UpdateCartItem(update)
      if (res_update.ok) {
        PXUTheme.jsAjaxCart.updateView()
      }
    }
  }))

  Alpine.data('MainCart', () => ({
    mounted() {
      let ti = setInterval(() => {
        if (document.querySelector('.is-cart-open')) {
          clearInterval(ti)
        }
        PXUTheme.jsAjaxCart.showDrawer()
      }, 500)
    }
  }))

  Alpine.data('StoreLocator', () => ({
    stores: [],
    filteredStores: [],
    qs_stores: [],
    maps: [],
    SELECTORS: {
      map: '.stockists-map'
    },
    selected: {
      searchQuery: ''
    },
    mounted() {
      let am = this
      am.LoadStores()
      am.LoadGoogleMapApi()

      // search 
      am.$watch('selected.searchQuery', am.FilterStores.bind(am))
    },
    LoadStores() {
      let am = this
      if (typeof stores !== 'undefined') {
        am.stores = am.filteredStores = stores
        stores.forEach((store, index) => {
          store.selected = index == 0

          let parser = document.createElement('a')
          parser.href = store.url
          store.url_text = parser.hostname
        })

        let qs_stores = new quickScore.QuickScore(am.stores, ["title", "map_address"], {
          minimumScore: 0.7
        });
        am.qs_stores = qs_stores;
      }
    },
    LoadGoogleMapApi() {
      let am = this
      // let api_key = am.$section.dataset.api_key;
      // let api_key = 'AIzaSyA_vBCCKsY5hMJSFPF-3KOurzxSZTbm_gg'
      let api_key = 'AIzaSyBVVG_fQpsRYB-aVj3C81J1VLwRnEA1u7k'
      let script = document.createElement('script')
      script.onload = function () {
        am.InitMap()
      }
      script.src = `https://maps.googleapis.com/maps/api/js?key=${ api_key }&callback=MapsLoaded`
      document.head.appendChild(script)
    },
    InitMap() {
      let am = this;
      (async() => {
        let store = await PXUTheme.utils.Geolocate(am.stores[0].map_address)
        store = store.results[0]
      
        let store_lat_lng = {
          lat: store.geometry.location.lat(), 
          lng: store.geometry.location.lng()
        };
      
        // Create the maps.
        document.querySelectorAll(am.SELECTORS.map).forEach(($map) => {
          const map = new google.maps.Map($map, {
            zoom: 4,
            center: store_lat_lng,
            styles: [{
              stylers: [{
                saturation: -50
              }]
            }],
          })
          am.AddMarkers(map)

          am.maps.push(map)
        })
      })()
    },
    AddMarkers(map) {
      let am = this;
      (async() => {
        let px_addresses = am.stores.map(async(store) => {
          return await PXUTheme.utils.Geolocate(store.map_address)
        })

        let addresses = await PXUTheme.utils.PromisesSequential(px_addresses)
        addresses = addresses.map(item => item.results[0]);
        
        addresses.forEach((address, index) => {
          let store = am.stores[index]

          const store_lat_lng = {
            lat: address.geometry.location.lat(), 
            lng: address.geometry.location.lng()
          }
      
          let marker = new google.maps.Marker({
            position: store_lat_lng,
            map: map,
            title: store.title,
            icon: '//thefullest.com/cdn/shop/t/57/assets/icon-map-circle.svg?v=144250447749627001601749195426'
          })

          // capture into store
          store.geometry = address.geometry
          store.marker = marker
          // console.log(store, address)

          // info modal
          let infowindow = new google.maps.InfoWindow({
            content: `
              <div class="map-stockist-wrap">
                <div class="stockist-title">${ store.title }</div>
                <div class="stockist-address">
                  <div>${ store.map_address.split(',')[0] }</div>
                  <div>${ store.map_address.split(',').splice(1).join(', ') }</div>
                </div>
                <div class="stockist-link">
                  <a target="_blank" class="link" href="${ store.url }">${ store.url }</a>
                </div>
              </div>
            `,
            ariaLabel: store.title,
          })
          store.infowindow = infowindow
      
          marker.setMap(map)
          // console.log(marker);
      
          marker.addListener('click', (e) => {
            // console.log(e)
            am.ZoomToStore(e, store)
          })
        })
      })()      
    },
    ZoomToStore(e, store) {
      let am = this;
      // console.log(e, store);
      am.stores.forEach((_store) => {
        _store.selected = false
      })
      store.selected = true

      document.querySelectorAll('.list-stores').forEach(($list) => {
        let $store = $list.querySelector('.selected')
        $list.scrollTo({
          top: $store.offsetTop
        })
      })

      am.maps.forEach(map => {
        map.setZoom(12)
        map.panTo(store.marker.position)

        store.infowindow.open({
          anchor: store.marker,
          map: map,
        })
      })
    },
    FilterStores() {
      let am = this;

      let searchQuery = am.selected.searchQuery;
      let search_stores = [];
      if (searchQuery !== '') {
        search_stores = am.qs_stores.search(searchQuery).map(item => item.item);
      }

      am.filteredStores = am.stores.filter((store, index) => {
        let flag = true;
        let search_match = search_stores.find(item => item.title == store.title);
        if (searchQuery !== '') {
          flag = search_match ? true : false
        }

        // console.log(store, flag)
        store.marker.setVisible(flag)

        return flag;
      })

      am.filteredStores.forEach((store, index) => {
        store.selected = index == 0
      })
    }    
  }))

  Alpine.data('BlogTagsFilter', () => ({
    e_SelectTag(e, index) {
      // console.log(e, index)
      let $target = e.currentTarget
      if ($target.classList.contains('selected')) return;

      let $dd_tag_filter = document.querySelector('#blog_filter')
      $dd_tag_filter.selectedIndex = index
      $dd_tag_filter.dispatchEvent(new Event('change'))
    }
  }))

  Alpine.data('MyAccount', () => ({
    active_tab: 1,
    mounted() {
      this.$el.classList.remove('visually-hidden')
    }
  }))

  Alpine.data('LoadMore', () => ({
    config: {
      PaginateItems: null,
      section_id: ''
    },
    mounted() {
      let am = this
      am.config.PaginateItems = JSON.parse(am.$el.dataset.paginate)
      am.config.section_id = am.$el.dataset.section_id
    },
    e_LoadNext(e) {
      let am = this;
      (async () => {
        let section_id = am.config.section_id
        let url  = `${ am.config.PaginateItems.next.url }&sections=${ section_id }`
        let res = await fetch(url).then((res => res.json()))
        let $section = PXUTheme.utils.ConvertStringToHTML(res[section_id])
        // console.log($section)
        let $OrderHistory = $section.querySelector('.order-history')
        if (!$OrderHistory) return
        let $order_cards = $OrderHistory.querySelectorAll('.order-cards .order-card')
        $order_cards.forEach(($card) => {
          document.querySelector('.order-cards').insertAdjacentElement('beforeend', $card)
        })
        am.config.PaginateItems = JSON.parse($OrderHistory.dataset.paginate)
      })()
    }
  }))

  Alpine.data('LoadSectionFromPage', () => ({
    config: {
      url: '',
      section_id: '',
      section_selector: ''
    },
    mounted() {
      let am = this;
      am.config.url = am.$el.dataset.url
      am.config.section_id = am.$el.dataset.section_id
      am.config.section_selector = am.$el.dataset.section_selector

      am.LoadPage()
    },
    LoadPage() {
      let am = this;
      (async() => {
        let url  = `${ am.config.url }`
        if (am.config.section_id) {
          url += `?section_id=${ am.config.section_id }`
        }
        let res = await fetch(url).then((res => res.text()))
        let $section = PXUTheme.utils.ConvertStringToHTML(res)
        if (!$section) return

        am.$el.insertAdjacentElement('beforeend', $section.querySelector(`.shopify-section ${ am.config.section_selector }`))
      })()
    }
  }))

  Alpine.data('CookieBar', () => ({
    SESSION_KEY: 'cbar',
    init() {
      let am = this;
      let session_cbar = JSON.parse(localStorage.getItem(am.SESSION_KEY));
      if (!session_cbar) {
        am.$el.classList.add('active');
      }      
    },
    e_CloseBar(e) {
      let am = this;
      e.target.closest('.cbar').classList.add('hidden');
      localStorage.setItem(am.SESSION_KEY, 'true');
    }
  }));

  Alpine.data('AllowOnePerCustomer', () => ({
    product_handle: '',
    cache: {},
    cart: null,
    flags: {
      is_ItemInCart: false
    },
    init() {
      let am = this;
      am.InitSelf()
      am.CheckItemInCart()

      document.addEventListener('ajaxcart:updated', (e) => {
        console.log(e)
        setTimeout(am.CheckItemInCart.bind(am), 1000)
      })
    },
    InitSelf() {
      let am = this;
      am.cache.$form = am.$el.querySelector('.shopify-product-form')
      am.cache.$btn_atc = am.$el.querySelector('.button--add-to-cart')
      am.product_handle = am.$el.dataset.product_handle

      // disable atc initially and enable after check
      am.cache.$btn_atc.disabled = true
    },
    async GetCart() {
      let am = this;
      let cart = await PXUTheme.utils.GetCart()
      am.cart = cart
    },
    async CheckItemInCart() {
      let am = this;
      await am.GetCart()
      let itemInCart = am.cart.items.find(item => item.handle == am.product_handle)
      am.flags.is_ItemInCart = itemInCart !== undefined
      // console.log(am.flags)

      am.cache.$btn_atc.disabled = am.flags.is_ItemInCart;
      am.cache.$btn_atc.querySelector('.text').textContent = am.flags.is_ItemInCart ? 'Added to Cart' : 'Add to Cart';
    }
  }));

  Alpine.data('SubscriptionProduct', () => ({
    product: null,
    selling_plans: [],
    selling_plan_id: '',
    qty: 1,
    init() {
      let am = this;
      am.product = JSON.parse(am.$el.dataset.product);

      // selling_plans
      if (am.product.selling_plan_groups.length) {
        am.selling_plans = [...am.product.selling_plan_groups].map((item, index) => {
          return {
            index: (index + 1),
            id: item.selling_plans[0].id,
            name: item.name,
            price_adjustment: {
              type: item.selling_plans[0].value_type,
              value: item.selling_plans[0].value
            }
          }
        });
        // console.log(am.selling_plans);
        am.selling_plan_id = am.selling_plans[0].id;
      }
    },
    e_QtyChanged(e) {
      // console.log(e)
      let am = this;
      let $input = e.currentTarget.querySelector('.quantity-input')
      am.qty = parseInt($input.value)
    },
    async e_AddItemToCart(e) {
      let $target = e.currentTarget;
      let $product = $target.closest('.product--action-subscribe')
      let qty = $product.querySelector('[name=quantity]').value

      let items_to_add = [{
        quantity: qty,
        id: $target.dataset.variant_id,
        selling_plan: $product.querySelector('.select-freq').value,
      }]
      await PXUTheme.utils.AddItemsToCart(items_to_add)
      PXUTheme.jsAjaxCart.updateView()
      PXUTheme.jsAjaxCart.showDrawer()
    }
  }));

  Alpine.data('CartUpsells', () => ({
    cart: {},
    product_bundle: null,
    cache: {},
    flags: {
      bundle_upsell: false
    },
    init() {
      this.InitCache();
      this.InitSelf();
      this.InitWatchers();
    },
    InitCache() {},
    InitSelf() {
      let am = this;
      am.cart = JSON.parse(am.$el.dataset.cart);
      am.UpdateFlags();
    },
    InitWatchers() {},
    UpdateFlags() {
      let am = this;
      let items_warm_feeling = am.cart.items.filter(item => item.handle.indexOf('warm-feelings') !== -1 && item.handle.indexOf('warm-feelings-bulk') == -1);
      let items_kinder_thoughts = am.cart.items.filter(item => item.handle.indexOf('kinder-thoughts') !== -1);
      let item_bundle = am.cart.items.filter(item => item.handle.indexOf('happy-habits-bundle') !== -1);
      am.flags.bundle_upsell = 
        (items_warm_feeling.length !== 0 || items_kinder_thoughts.length !== 0) && 
        item_bundle.length == 0;
    },
    async e_AddItemToCart(e) {
      let $target = e.currentTarget
      let items_to_add = [{
        quantity: 1,
        id: $target.dataset.variant_id
      }]
      await PXUTheme.utils.AddItemsToCart(items_to_add)
      PXUTheme.jsAjaxCart.updateView()
    }
  }));
})

// Okendo review stars badge click
document.querySelectorAll('[data-oke-star-rating]').forEach(($rating) => {
  $rating.setAttribute('x-data', 'ScrollTo');
  $rating.setAttribute('data-target', '.okendo-reviews-container');
  $rating.addEventListener('click', (e) => {
    $rating.dispatchEvent(new CustomEvent('ScrollTo', {bubbles: true}));
  });
});

// 22-10-2024 start
document.addEventListener('DOMContentLoaded', function() {
  // 23-01-2025 start
    // if (document.body.classList.contains('warm-feelings-bulk-saffron-latte') && document.querySelector('#generic-promise-wc-sdk') !== null) {
    //   document.querySelector(".custom-sub-widget-v2").style.display = "none";
    // }else if(document.body.classList.contains('warm-feelings-bulk-saffron-latte') && document.querySelector('#generic-promise-wc-sdk') == null){
    //   document.querySelector(".custom-sub-widget-v2").style.display = "block";
    // }
  
    setTimeout(function() {
        let customPrice = document.querySelector('.custom_price');
        if (customPrice) {
            customPrice.style.display = 'block'; // Show the element after 0.5 seconds
        }
    }, 500); // 500 milliseconds = 0.5 seconds

    setTimeout(() => {
      if (document.body.classList.contains('warm-feelings-bulk-saffron-latte') && document.querySelector('#generic-promise-wc-sdk') !== null) {
        document.querySelector(".custom-sub-widget-v2").style.display = "none";
        document.querySelector("#shop-floater").style.display = "none";
      }
    }, 2000);
      
});
// 22-10-2024 end

